import { css } from '@emotion/react';
import { IonSpinner, SpinnerTypes } from '@ionic/react';
import React from 'react';

interface SpinnerProps {
  type: SpinnerTypes;
  color?: string;
  size?: string | number;
  slot?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ type, slot, size = null, color = null }) => {
  const spinnerCss = {
    self: [
      css(
        size !== null
          ? {
              width: size,
              height: size,
            }
          : {}
      ),
      css(color !== null ? { color } : {}),
    ],
  };

  return <IonSpinner name={type} css={spinnerCss.self} slot={slot} />;
};
